<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4" v-if="currentPost">
          <div class="card-header pt-1 pb-0">
            <div>
              <h3 class="card-title text-primary mb-0 mt-2">{{ currentPost.title }}</h3>
              <div class="sub-line"></div>
              <div class="row col-12 mt-3">
                <router-link :to="{ name: 'Noticias' }"
                             class="col-md-2 col-6 col-md-offset-10 btn btn-primary btn-sm text-white bg-blue-600 rounded-lg hover:bg-blue-900 mb-0  ml-auto">
                  Ir al listado
                </router-link>
              </div>
              <h6 class="card-title text-primary mb-0 mt-2">{{ currentPost.externalLink }}</h6>
              <p>
                <span title="Provincia"><i class="fas fa-map"></i> {{ currentPost.province.name }}</span>
                <span title="Publicado" style="margin-left: 200px;">Fecha de publicación <i class="fas fa-calendar ml-2"></i> {{currentPost.publishedAt}}</span>
                <span title="Fin de publicación" style="margin-left: 200px;">Fecha de fin de publicación <i class="fas fa-calendar ml-2"></i> {{currentPost.dueDate}}</span>
              </p>
            </div>
          </div>
          <div class="card-body">
            <img class="post-image" :src="currentPost.imageUrl" alt="image">
              <p>{{ currentPost.content }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useStore } from "vuex";
import {computed, onMounted} from "vue";
import { useRoute } from "vue-router";


    const route = useRoute();
    const store = useStore();

    const getCurrentPost = async (id) => {
      return await store.dispatch("post/getPostById", id);
    };

    const currentPost = computed(() => store.state.post.currentPost);

    onMounted(getCurrentPost(route.params.id));



</script>
<style>
.post-image {
  width: 100%;
  max-width: 800px;
  height: auto;
  margin-bottom: 15px;
}
</style>
